import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';
import { type CurrencyFormat } from '@utils/currency/formatToCurrency';

import { type SettingState } from '../types';

const changeCurrencyFormatCase: CaseReducer<
  SettingState,
  PayloadAction<{ format: CurrencyFormat }>
> = (state, action) => {
  state.currencyFormat = action.payload.format;

  return state;
};

export { changeCurrencyFormatCase };
